// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"453":"gift","661":"gift-detail","699":"art-trade","720":"heritage","996":"cultural-mall"}[chunkId] || chunkId) + "." + {"453":"919dff25","457":"91af35c5","661":"134fe606","699":"09b2ecb5","720":"a065cc9f","996":"7bb0b715"}[chunkId] + ".css";
};